import { FC } from "react";

interface Props {
  position: number;
}

export const Position: FC<Props> = ({ position }) => (
  <div className="candidate-list__table__row__position">
    <span>{position}</span>
  </div>
);
